
import Vue from "vue";
import store from "../../store";
import { mapGetters } from "vuex";
import { IAppProperties } from "../../types";

export default Vue.extend({
  computed: {
    appProps: {
      get(): IAppProperties {
        //@ts-ignore
        return store.getters.appModule.getAppProperties;
      },
      set(appProd: IAppProperties) {
        //@ts-ignore
        store.commit.appModule.SET_APP_PROPERTIES(this.appProd);
      }
    },
    isErrorInForms(): boolean {
      return this.appProps.validInvoice && this.appProps.validBillingInfo;
    }
  }
});
